export default __webpack_public_path__ + "static/commercial-08d580c5e59108657bbe28b33d4dbd46.png";